module.exports = __webpack_public_path__ + "static/media/arrow-up.70c554c6.svg";